import type { NotifyPort } from '@/features/messages/domain/notify'
import type { CompanyWorkflow, Member, Team, WorkflowPort } from '../domain/workflow'

const listWorkflows = async (port: WorkflowPort, notify: NotifyPort): Promise<CompanyWorkflow[]> => {
	try {
		const all = await port.listAll()
		return all.filter(w => w.status === 'active')
	} catch {
		notify.error('workflow.loadFailed')
		return []
	}
}

const listAllWorkflows = async (port: WorkflowPort, notify: NotifyPort): Promise<CompanyWorkflow[]> => {
	try {
		const all = await port.listAll()
		return all.filter(w => w.status !== 'deleted')
	} catch {
		notify.error('workflow.loadFailed')
		return []
	}
}

const listTeams = async (port: WorkflowPort, notify: NotifyPort): Promise<Team[]> => {
	try {
		return await port.listTeams()
	} catch {
		notify.error('workflow.teamsLoadFailed')
		return []
	}
}

const listTeamMembers = async (port: WorkflowPort, teamId: string, notify: NotifyPort): Promise<Member[]> => {
	try {
		return await port.listMembers(teamId)
	} catch {
		notify.error('workflow.teamMembersLoadFailed')
		return []
	}
}

export { listWorkflows, listAllWorkflows, listTeams, listTeamMembers }
